/**
 * Inbox messages state Name
 */
export const MESSAGE_TEMPLATES = 'MESSAGE_TEMPLATES';
